
import Mask2 from "../../../assets/duotone/Mask2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Mask2Icon({ className, dataTestid = "Mask2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Mask2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
